export default __webpack_public_path__ + "static/media/logo-small.9e76d5aa.webp";